import { PropsWithChildren, useEffect, useMemo } from 'react'
import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { activateAppLanguage, defaultLanguage } from '@/i18n'
import { resolveLanguage } from '@/language-policy'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

export function LanguageProvider({ children }: PropsWithChildren<{}>) {
  const authUser = useAppSelector(selectAuthUser)

  const language = useMemo(
    () => resolveLanguage(authUser?.userInfo?.language ?? defaultLanguage),
    [authUser],
  )

  useEffect(() => {
    void activateAppLanguage(language).catch((error) => console.error('Failed to activate application language', error))
  }, [language])

  return (
    <I18nProvider i18n={i18n} defaultComponent={DefaultComponent}>
      {children}
    </I18nProvider>
  )
}

function DefaultComponent({ children }: PropsWithChildren<{}>) {
  return <div>{children}</div>
}
